export interface Rgb {
  r: number;
  g: number;
  b: number;
}

export interface Rgba extends Rgb {
  a: number;
}

/** Hue (0-359) of an RGB colour. Grey/white/black all report hue 0. */
export function rgbToHue({ r, g, b }: Rgb): number {
  const max = Math.max(r, g, b);
  const min = Math.min(r, g, b);
  const delta = max - min;

  if (delta === 0) {
    return 0;
  }

  let hue: number;
  if (max === r) {
    hue = ((g - b) / delta) % 6;
  } else if (max === g) {
    hue = (b - r) / delta + 2;
  } else {
    hue = (r - g) / delta + 4;
  }

  hue = Math.round(hue * 60);
  return ((hue % 360) + 360) % 360;
}

/**
 * Fully saturated RGB for a hue, i.e. hsl(hue, 100%, 50%).
 * Matches what react-color's HuePicker used to hand back.
 */
export function hueToRgb(hue: number): Rgb {
  const h = (((hue % 360) + 360) % 360) / 60;
  const x = Math.round(255 * (1 - Math.abs((h % 2) - 1)));

  switch (Math.floor(h)) {
    case 0: return { r: 255, g: x, b: 0 };
    case 1: return { r: x, g: 255, b: 0 };
    case 2: return { r: 0, g: 255, b: x };
    case 3: return { r: 0, g: x, b: 255 };
    case 4: return { r: x, g: 0, b: 255 };
    default: return { r: 255, g: 0, b: x };
  }
}
